import { AdvisorProfileModule } from "./AdvisorProfileModule";
import { ContactSectionModule } from "./ContactSectionModule";
import { CtaModule } from "./CtaModule";
import { FaqModule } from "./FaqModule";
import { HeroModule } from "./HeroModule";
import { ImportantDisclosuresModule } from "./ImportantDisclosuresModule";
import { InfoCardGridModule } from "./InfoCardGridModule";
import { LeadFormModule } from "./LeadFormModule";
import { MediaTextSectionModule } from "./MediaTextSectionModule";
import { ProcessStepsModule } from "./ProcessStepsModule";
import { QuoteSectionModule } from "./QuoteSectionModule";
import { ResourceListModule } from "./ResourceListModule";
import { CmsPageShell } from "./CmsPageShell";
import {
  buildDisclosureFootnoteRegistry,
  DisclosureFootnoteProvider,
} from "./disclosureFootnotes";
import type { CmsModuleRenderProps, CmsPageRenderProps } from "./renderProps";

export function CmsModuleRenderer(props: CmsPageRenderProps) {
  const disclosureFootnotes = buildDisclosureFootnoteRegistry(props.modules);

  return (
    <CmsPageShell page={props}>
      <DisclosureFootnoteProvider registry={disclosureFootnotes}>
        {props.modules.map(renderModule)}
      </DisclosureFootnoteProvider>
    </CmsPageShell>
  );
}

function renderModule(module: CmsModuleRenderProps, index: number) {
  const key = module.moduleId ?? index;

  switch (module.moduleType) {
    case "HERO":
      return <HeroModule key={key} {...(module.hero ?? { headline: "" })} />;
    case "CTA":
      return (
        <CtaModule key={key} {...(module.cta ?? { label: "", url: "" })} />
      );
    case "ADVISOR_PROFILE":
      return (
        <AdvisorProfileModule key={key} {...(module.advisorProfile ?? {})} />
      );
    case "CONTACT_SECTION":
      return (
        <ContactSectionModule key={key} {...(module.contactSection ?? {})} />
      );
    case "LEAD_FORM":
      return (
        <LeadFormModule
          key={key}
          {...(module.leadForm ?? { submitLabel: "Send message" })}
        />
      );
    case "INFO_CARD_GRID":
      return (
        <InfoCardGridModule
          key={key}
          {...(module.infoCardGrid ?? { items: [] })}
        />
      );
    case "MEDIA_TEXT_SECTION":
      return (
        <MediaTextSectionModule
          key={key}
          {...(module.mediaTextSection ?? {})}
        />
      );
    case "PROCESS_STEPS":
      return (
        <ProcessStepsModule
          key={key}
          {...(module.processSteps ?? { steps: [] })}
        />
      );
    case "QUOTE_SECTION":
      return (
        <QuoteSectionModule
          key={key}
          {...(module.quoteSection ?? { quote: "" })}
        />
      );
    case "RESOURCE_LIST":
      return (
        <ResourceListModule
          key={key}
          {...(module.resourceList ?? { items: [] })}
        />
      );
    case "IMPORTANT_DISCLOSURES":
      return (
        <ImportantDisclosuresModule
          key={key}
          {...(module.importantDisclosures ?? {
            paragraphs: [],
            footnotes: [],
          })}
        />
      );
    case "FAQ":
      return <FaqModule key={key} {...(module.faq ?? { items: [] })} />;
    default:
      return null;
  }
}
